import { connect } from "react-redux";
import { signIn, signOut } from "../../redux/actions/authActions";
import { updateTransParams } from "../../redux/actions/transactionParamsAction";
import {
  transactionTableFetch,
  transactionTablePreviousFetch,
  transactionTableContinuationToken,
} from "../../redux/actions/transactionTableAction";
import {
  dailyAnalyticsFetch,
  monthlyAnalyticsFetch,
  weeklyAnalyticsFetch,
} from "../../redux/actions/analyticsInfoAction";

function actionSelector(identifier) {
  const data = {
    signIn: signIn,
    signOut: signOut,
    updateTransParams: updateTransParams,
    transactionTableFetch: transactionTableFetch,
    transactionTablePreviousFetch: transactionTablePreviousFetch,
    transactionTableContinuationToken: transactionTableContinuationToken,
    dailyAnalyticsFetch: dailyAnalyticsFetch,
    weeklyAnalyticsFetch: weeklyAnalyticsFetch,
    monthlyAnalyticsFetch: monthlyAnalyticsFetch,
  };

  return data[identifier];
}

const decomposeIdf = (obj, idf) => {
  return idf.split(".").reduce((o, key) => {
    if (o[key]) {
      return o[key];
    }

    return "";
  }, obj);
};

const mapStateToProps = (propMapperArray) => (store) => {
  return propMapperArray.reduce(
    (o, { key, identifier }) => ({
      ...o,
      [key]: decomposeIdf(store, identifier),
    }),
    {}
  );
};

const mapDispatchToProps = (dispatchMapperArray) => (dispatch) => {
  return dispatchMapperArray.reduce(
    (o, { key, identifier }) => ({
      ...o,
      [key]: (data) => dispatch(actionSelector(identifier)(data)),
    }),
    {}
  );
};

const connector = (propMapperArray, dispatchMapperArray) => (Component) => {
  return connect(
    mapStateToProps(propMapperArray),
    mapDispatchToProps(dispatchMapperArray)
  )(Component);
};

export default connector;
